import React from 'react';
import DragAndDropFile from './DragAndDropFile';
import ImportDateSelection from './ImportDateSelection';
import ImportPlatformSelection from './ImportPlatformSelection';
import ImportTypeSelection from './ImportTypeSelection';

const ImportMainContent: React.FC = () => (
  <div className="w-3/5 pr-10 h-full flex flex-col gap-1 text-body bg-white">
    <div className="h-full flex flex-col gap-10">
      <span>Import Details</span>

      <div className="h-full flex flex-col gap-8">
        <ImportTypeSelection />
        <ImportDateSelection />
        <ImportPlatformSelection />
        <DragAndDropFile />
      </div>
    </div>
  </div>
);

export default ImportMainContent;
